import ResumeProfileEmployerListItem from './ResumeProfileEmployerListItem'

export default ResumeProfileEmployerListItem
